import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'Douleutaras/redux/store';
import { LANGUAGE_CODES } from 'Douleutaras/constants/system';
import { SITE_COUNTRY_CODE } from 'Douleutaras/constants/localization';

export const getLanguageFile = async (lang = 'en', countryCode) => import(/* webpackChunkName: "i18n." */ `Douleutaras/data/footerLinks.${lang}.${countryCode}.json`);
export const fetchFooterLinks = createAsyncThunk(
  'footer/getFooterLinks',
  async ({ language, countryCode }: { language: LANGUAGE_CODES, countryCode: SITE_COUNTRY_CODE}) => {
    const links = await getLanguageFile(language, countryCode);

    // convert to plain object
    return { ...links };
  }
);

export const footerLinksSlice = createSlice({
  name: 'footerLinks',
  initialState: {},
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchFooterLinks.fulfilled, (state, action) => {
      return action.payload;
    });
  }
});

export default footerLinksSlice.reducer;
export const footerLinksSelector = (state: RootState) => state.footerLinks;
